

export default function TableCell(props) {

		//this builds the row
		let {currentItem, currentRow} = props
		let basicContent = currentItem.basicContent
		let compareTableContent = currentItem.compareTable
		//let compareTable = currentItem.compareTable

		let cellClass
		let imgCellClass
		let learnMoreButtonClass
		let learnMoreText
		//assign classes based on item selected


		if (props.selectedItemId === basicContent.itemId ){
			cellClass = 'chartCellSelected'
			imgCellClass = 'imgCellSelected'
			learnMoreButtonClass = 'compareTable-button selected-CompareTableButton'
			learnMoreText = 'Viewing'
		} else {
			imgCellClass  = 'imgCell'
			cellClass = 'chartCell'
			learnMoreButtonClass =  'compareTable-button notselected-CompareTableButton'
			learnMoreText = 'Learn More'
		}

		//className={imgCellClass}

		let onClick = ()=> props.passedSetState('selectedItemId', basicContent.itemId )

		//on mobile I need all noselected rows to dissapear

		//* might need to make width 100% for IE

		let affiliateGoToPageHref="https://linksynergy.walmart.com/deeplink?id=mZBF1JmBhNo&mid=2149&u1=GTP&murl=http%3A%2F%2Fwww.walmart.com%2Fip%2F" + basicContent.itemId

		if (currentRow.id === 'img'){
			return (
				<div style={{backgroundColor: '#fff'}}  className={imgCellClass} >

					<div style={{padding: '10px 0px', width: '100%'}} className='row' onClick={onClick} >
						<div >
	        		<img src={basicContent.largeImage} style={{ width: '100%', backgroundColor: props.rowBackgroundColor}} />
						</div>
					</div>

					<div style={{padding: '10px 0px', width: '100%'}} className='row' >
						<div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
							<a data-contenttype="ct" data-btnlocation="cell" data-itemid={basicContent.itemId}
								alt='Go To Page' href={affiliateGoToPageHref} target='_blank' rel='noreferrer noopener'
								style={{ textDecoration: 'underline'}}
							>Go To Page ›</a>
						</div>
					</div>

					<div  className='row' style={{width: '100%'}} >
						<div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
							<button data-contenttype="ct" data-btnlocation="learnmore" data-itemid={basicContent.itemId} className={learnMoreButtonClass} native onClick={onClick} >
								{learnMoreText}
							</button>
						</div>
					</div>

				</div>
			);
		} else if (currentRow.id === 'moreContent'){

			if (props.selectedItemId === basicContent.itemId) {
					return (
						<div style={{backgroundColor: '#CB2C90', borderRadius:'0px 0px 10px 10px'}} onClick={onClick} className={'moreContent-chartCell chartCellSelected'} >
								<img src='https://firebasestorage.googleapis.com/v0/b/columbus-c4de8.appspot.com/o/util%2Fcarat_down.png?alt=media&token=67286cc3-5bec-47cf-8e5c-f828097a413d' style={{height: '14px'}} />
						</div>
					);
				}
				return (
						<div onClick={onClick} className={cellClass} />
				)

		} else if (currentRow.id === 'name'){

			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
					<b className='chartCellTitle'>{basicContent.shortName}</b>
				</div>
			);
		} else if (currentRow.id === 'salePrice'){

			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
					<span className='productModule-price'>${basicContent.salePrice}</span>
				</div>
			);
		} else if (currentRow.id === 'color'){

			let colorHTML = []
			let colors = compareTableContent && compareTableContent.colors
			for(let key in colors){
				if(colors.hasOwnProperty(key)) {
							let currentColor = '#' + key
							colorHTML.push(
							<div style={{maxWidth: '22px', width: '100%', height: '100%', padding: '2px'}} >
									<div style={{ height: '20px', width: '20px', backgroundColor: currentColor, borderRadius: '50%', paddingTop: '100%', border: '1px #ddd solid' }} />
							</div>
						)
				}
			}

			return (
				<div style={{backgroundColor: props.rowBackgroundColor, flexDirection: 'row'}} onClick={onClick} className={cellClass} >
					{colorHTML}
				</div>
			);
		} else if (currentRow.id === 'instantRebate' ){

			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
					<span style={{fontSize: '20px', fontWeight: 700}}>{compareTableContent && compareTableContent.instantRebate ? '$' + compareTableContent.instantRebate + ' off' : ''}</span>
				</div>
			);
		} else if (currentRow.id === 'mailInRebate' ){

			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
					<span style={{fontSize: '20px', fontWeight: 700}}>{compareTableContent && compareTableContent.mailInRebate ? '$' + compareTableContent.mailInRebate + ' off': ''}</span>
				</div>
			);
		} else if (currentRow.id === 'brushingModes' || currentRow.id === 'headsIncluded'){
			let currentCellContent = compareTableContent && compareTableContent[currentRow.id]
			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
					<span>{currentCellContent}</span>
				</div>
			);
		}

			let currentCellContent = compareTableContent && compareTableContent[currentRow.id]
			return (
				<div style={{backgroundColor: props.rowBackgroundColor}} onClick={onClick} className={cellClass}>
						{ currentCellContent  ?  'Y' : '' }
				</div>
			);


}



// WEBPACK FOOTER //
// ./components/contentTypes/compareTable/tableCell.js